module.exports = __webpack_public_path__ + "static/media/location-icon-moltoAlta-severity-2.25435d7b.png";